import { Vector3 } from "three";
import { ImageUtils } from "../../infra3d";
import { GEOMETRYTYPE } from "../featuretree/internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { Tool } from "./internal";
/**
 * Orthogonal Measurement Tool
 * @class OrthogonalMeasurementTool
 * @extends {Tool}
 */
export class OrthogonalMeasurementTool extends Tool {
    constructor(scene, toolhandler, options, name, group) {
        super(scene, toolhandler);
        this.coordinates = [];
        // --- Algorithm Parameters
        /**
         * Histeresys Active. When a line was found the line will be visible until the mouse moves more than histthresh px..
         * @property {boolean} hist_active
         * @default false
         **/
        this.hist_active = false;
        this.histthresh = 5;
        /**
         * Threshold for filtered image to binary image conversion.
         * @property {number} threshold
         * @default 255
         **/
        this.threshold = 255;
        /**
         * default Threshold for filtered image to binary image conversion.
         * @property {number} defaultthresholdval
         * @default 120
         **/
        this.defaultthresholdval = 120;
        this.wwidth = 300;
        this.wheight = 150;
        this.htindex = [];
        this.linecoordinates = [];
        this.min = 0;
        this.max = 0;
        this.mean = 0;
        /**
         * the increment on a line for hough transform counts every 3rd pixel increase this for speed
         * @property {number} htinc
         * @default 3
         */
        this.htinc = 3;
        /**
         * max allowd gap on a line in pixel.
         * @property {number} maxgap
         **/
        this.maxgap = 30;
        this.peakthresh = 80;
        this.finishinputevent = null;
        this.resetinputevent = null;
        this.distance = 0;
        this.imgbuffer = null;
        this.snap_mx = null;
        this.snap_my = null;
        this.snappedpos = null;
        this.mouseouteventnr = null;
        this.detectionInProgress = false;
        // web worker related variables
        this.worker = null;
        this.multipointfeature = null;
        this.name = name;
        this.group = group;
        this.cursordiv = document.createElement("canvas");
        this.cursordiv.style.position = "absolute";
        this.cursordiv.width = this.wwidth;
        this.cursordiv.height = this.wheight;
        this.cursordiv.style.width = this.wwidth.toString() + "px";
        this.cursordiv.style.height = this.wheight.toString() + "px";
        this.cursordiv.style.pointerEvents = "none";
        this.cursordiv.style.position = "absolute";
        this.cursordiv.style.visibility = "hidden";
        this.cursordiv.style.backgroundImage =
            "url('data:image/gif;base64,R0lGODlhMgAyAPIAAP////////7+/v////7+/v7+/v7+/v7+/iH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAMgAyAAAD+wi63P4wykmrvTjrJQQrW8gMw0IMhiiSHLqA6sUqg6cQQhpXszEcLd1uMjsMCLffkFcCCAagQg0GOCCXDpbUZrxWldgGywf02b7AsLhkTD11xrR6xPac0vGPEDtTGEF5Jh1zfQqAYAAGBwIHe0uFhowKih1eapCGAAU4AgRUhE0OBR0Hn5qmMZgmQgUGBAewqCuhEK2vjFaOqbQOOLAEBrI7qguuumoElnNLm8nOz8u1z9PK0dYbBsHXFa7JwcLbmtnP2uGGn63d5pPZouDL6e/WBVTZ5eunVOn35vTo7fjyNZAHj17AWgYPuiMYjqHChxAjSpxIsaJFawkAACH5BAkKAAAALAAAAAAyADIAAAP/CLrc/jDKSau9OOPCzmGcph0DsQzDQgyGmK3CIqQKGQK3GxWoTAOCmMIgaOkkM+NAaBh8FMHc0bF6zhQrEyA7lfCES+iAUwgyCMauj3MtC0npg0CrrpUAveaH+ATI+3VbTngpcEBFNQKAgTwpBiYEMVWJgAVSRzOXchx/Zx6BJHQgfooLBn9pXU1CDmVPBZEHqXU9EGQEcgSXakk7uVKWdZMRaCCPn2qrFAXHHmizRyi7Kh4HaNNHhhEGBtjJB96BU7CP5WjF4l7n5uXp7u6W4e8N3PXB8xOW9dz3+KMgzLj5axDvgTxx8Q4OTDiwQsGGyxRCnEixosWLGDNq3MixB6PHjyDnJQAAIfkECQoAAAAsAAAAADIAMgAAA/8Iutz+MMpJq70448LOWQWnacZALIKwEIIxViJQDKqSLocQx29nogNUDXBTGFq9BmEQVBwGLmLt+HHqko1ndVktLqOsE5YxG3BmtWLuLDjECNHkMm2WytoKVjw8JkIBTyc3JScFeHkCYmMlKiUfN1+AVwB8fTY/eAYuBB9HYpUKIVhlPEpXoAAGHmNaEhygBpwEpS9MtGQHYgWcB3FjcxNnqr23SQJ/rrKlolglTRKaZJoEisY/FAXT1HDFGaQTsdQGzJaANMHj5Q+H6u2hmvDx3e7Z8fLu+Ork+TAh/vwW/AkEiO0fQRgHEypcyLChw4cQI0qcSLGixYsYM2qsmAAAIfkECQoAAAAsAAAAADIAMgAAA/sIutz+MMpJq70448LOYZymGQOxCMJiCIZYhUAxfAq6HALsQqRZp78bDWA4tHYM0uA2ONpiAh/Ao0NOZ4peEEBgZaPWLmMw4MiAT5zZkzxiBAMgN14rA54CWtdNMIrgcnAtBE13KSsmBWwKfVIagFl0JB82e1MHIY1WkFcmeUSDH4iMB44FVRaQZxJ9HJoqBI5vdKgOrqULBbEGtal0L7EKBQa7Vne/FCHEBG7GnBW7qL2+chO8IMMGzX/IydnavNMXzxLg2uLcOROn6EiCxsbbEOz07PAX9fX3+/z9/v8AAwocSLCgwYMIEypcyLChw4cQI0qcSLGixYUJAAAh+QQJCgAAACwAAAAAMgAyAAAD/wi63P4wykmrvTjjwgjRYGMIn3IIi3EYIcUphXAsx6wQx9tCYwkIKJMNUFsUCLodoDAIEgUsoq1w8OGSysOgZNgKFaOoKtq6LgQDTsxWBJjdPoABW9E6CQMb8CsFr1IEZBhoTmgseCxFMSxUPgaBLYRgTXJ5PzMjHG+PghUGgpJEXlVyLCpypHKQDHQNeHk6kkxDDyocnKyfE0cDvT6yLqpkBZ9zFlpNUWitEKulxhtoTWogxNAgI720F8XMGK9eG1gF5N4RVL1QGuXsLTHp5qztSim9li7xZen0Smv8/wADChxIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIMQJhAgAh+QQJCgAAACwAAAAAMgAyAAAD/wi63P4wykmrvTjjwgjRYGMIxnIci3Fw4cQChYAqZ7q20ljSgjkDnkWB8MLBBD0FQcCqwQ47gIFo7Aw+UgHWqdoNoyEVA8mJzZyEX1BYtBwGSengzASgsdNXwdB2z00kQIE1BVAwBFF7YBlvSQZ/MR81Khx5Cnt9EwZgb2dXdh+bUh9fl6IZA3MvnUc/D5aYDAWzFEupWHZwMBRlp5e0FYWpgbmZEL6zxhIxw2UgycqyvgojqYsWyRcEqXNUSnEZ0a8HAtxwhlUgKuXcMtfpvGnmcN7wF0Ps3Oj2F+uprvzu1QtIsKDBgwgTKlzIsKHDhxAjSpxIsaLFixgzatzIsQWjx4MJAAAh+QQJCgAAACwAAAAAMgAyAAAD6Qi63P4wykmrvTjrRcj+S3EYnKcURAFeogl0i5GukSGQynGU/GmotJNgpyAcgDAACgcwMIMvgalwK05nyh/NQMwJgAdTUhZ7AjOHQdcmJiYJuIL2VDhj0t3Dt1mFLRVOIXUgeEI7LS8eMipOQHV2FYELhVEkfipyWY6DGFRqZ4VULg+ZSpwZNgNSk2pKFo8rBAOqOHqQEqcgIrNHrlATkjECs7e/DQWzalgvXcYRBMPJQ0/OFFzRqtUZcjra3s7YyeLj4qNQ4eTps+bf7e7v8PHy8/T19vf4+fr7/P3+/wADChxIsKBBBwkAACH5BAkKAAAALAAAAAAyADIAAAPzCLrc/jDKSau9OOtlzP5LcXgKQYRGAV7iqRguUJArJNImF3eMWoeHA+fgg3F8MuQPYBCQbi/XzFeo1oyLoO/gwvIU1hpBIHwJXISy96lcHciLtMpAZJ6m4LYbLgv2PUZ4YSApDGNlYx4EHlYzeSsFAmdIb2VcEoOEAgNOcXB6SxBjAyMKb6ChNm+kKqipLzQvB5yurwUDnFxIaa8TaZu4ZLG9EzCSwcQZdDHJzTWzuNHRzCi1G7OS2cfMdMBlzg0Fo9Kd4DJp0pyL5kyr0cLsAOPBuvFg7wTWzlzD9v7/AAMKHEiwoMGDCBMqXMiwocOHBBMAACH5BAkKAAAALAAAAAAyADIAAAP1CLrc/jDKSau9OOtVyv4c4SmGwYzgRZgkC3SpVKyLQdQuHEPFcZOiFge1cxgOrBmrpNAVmz8F4TCiAZgvYpEgiPZ+NmH2yeBGp56ZB+skA8xN34vGbMcMRPgVeTXB7CkCXWWDb1FuDUeCLnBaiImCfG9UjxMzgkGOlXgNPYKajwWCXZxAlRBTggMCPi6nETYHAgMDB68VBUeHt7wYsqPAhb0Av8GYDz22w6i0Ar25B8oks7WgRYq0q03UAtYxXNmrfD3Nu4jZPigE2eaPWDXUlMsc3K7zB9n2y+u07cu08uY1sCKwoMGDCBMqXMiwocOHECPOSwAAIfkECQoAAAAsAAAAADIAMgAAA+4Iutz+MMpJq70461XK/pzhKR1oitxoVgWhGka6Wi0RjuXMEjFQoD6VrtFiEGwKGEk4XBgOSB8v2cs1G8+oweVDWa+MLGkK8DJ1X3GZCwQrDtBwHEB2ywWHXnluhzzxI09nfRwEBwJcg25tY4CEDQJ4PC9Rj0mHkZJ6lg4tmHicE1uVoaUSn5mZm5aoqQKrYaYRAgOwYD9wD7QCijNbtAMDAg67dobAwnULu70mwXhtBMMKxX2MZcAxzKUFB88e1aHewj3bnATBA1HhnMEHKuahSsvCssTCzZbs9gDevPxGpgEcSLCgwYMIEypcSCEBACH5BAkKAAAALAAAAAAyADIAAAP8CLrc/jDKSau9OOvNY+mgU3yhVhgkMJabYSwrm51pLHvv4sLp/RiEnAqlsPl+QRjReHQAhTtV72h8FpdTH+EgBFi92WZhm1R8mxHggUAChtHKw/qNZo7l9KN8TSwS4EhyAnJ9gDhbAoOGFWNdi48WW3uTXJAKBIOUBwKOlhiKi0B/DwQDAnB3iaYPBQMDeS2bAqYCZQ4HAwdUiYOFWw0GrmhROrOvDLOjhgW4uR9tq4uYpjmzH66dPgaztQvcY9GAswcpuAIjrrAlxADcCri6nu2mH8ED8vOnCrPZgOYkpfR52sYAG74G8A4ysKfOUDBlCs00jEixosWL+BIAACH5BAkKAAAALAAAAAAyADIAAAPyCLrc/jDKSau9OOvNu/+gVYRgMZKdeaKVybhsa6wAHE+FYSz2LeU7Rc8npAGLxAaBEBTOkEnncnWMOgrLZ61pbRiyNOswN+0qCAcmN2dWfNGHtLb9escJdEg1z3fA44BxXFZ/gYJ9GQYHgzdvEQcDeDc5BwKWBxECA2EfX5WXTBEFAwIxoHOKDwQDmCxzQpACnJCMLAWVrCNhAwNRBJoCQZBUpEQGwJIAsTCrrTeXK7E1xZq1IToM0sqsALxt2gbF4aVd2gDV28lJ5qvkmpyNzt2b0718kK3h8maj9Ol84ZK960OMHCI33A46gaewocMoCQAAIfkECQoAAAAsAAAAADIAMgAAA+wIutz+MMpJq7046827/2AojmQZFqZWrGm2ou31xhG8zLRjGDaA57cd78YCMgpCWNF43PWAy4WQCSAQnMcnDWm1YqlZQ9cAfiDJ5XSjy+5qY+02Wn2x5gpXyWCQ4h4OAgd6fCNif4EHQ4MkfwdXNmIRAoQiUT6AAm8AezF4AoEob5MtBp+JCoBanCUGmHMHAweWoyWABDawggWBDKskiqixwQQAvLQxuQoGAwIAy82+KckKk2SwxMcmBMLK3JMo0ayCC98+zNSUOdvjy+PhLQXnwWjZMaXE6DDv8DfyxelM2i3YB4XBJzoIE1JJAAAh+QQJCgAAACwAAAAAMgAyAAAD9gi63P4wykmrvTjrzbv/YCiOZGmeaKqubLsUsCvBhRzRtf3gdt7QMoMwxvCxYMIkUacoJIXM3zIaNRCs2CvBuMp6t1RM4WBQOcsRw0BgchIIhwNhMhiMrPD4lfsQDPgccHsMVhIEA3MhUwAFBAIHgE1rJ416NZEAdSYGB485jpEHA2ghnI+kjgeMD4eqInoMqYyPDgWTIlOyAIdztG8AfpgeugUCbGqqfgCiiSS6y6O7iMB2yCXP1tQ1yplsJJwMxpfGCtzBKbwK2dzMKMUCOaJo3GremwLN4uV2CnXCHj5s2eNGrVkKNc00KWjVwkicImEiSjyRAAAh+QQJCgAAACwAAAAAMgAyAAAD/Ai63P4wykmrvTjrzbv/YCiOZGmeaKqubOu+cCwDxewUeG0reb/TPd0P95sVDMhkUsg6KpXMouQgiJKck8PgUMIZCGADZTCwbo7gsMHsIAwEITXzSxEMxB8io0A4HNgLBmRdBn5rNBN2BCNfBwQ6fYA0ZJIWfI54AAQCi5JaXB99mZqcCgKgEGSjZ0ybi6RijgB0VLNvJK48p5NcAnBai4oiuQpUYm5ivrZcggNxpQoGuwBUNcoAt9RbIHwM1aZwANd2NQWUuNDSr9dur27hIQXTmnfg0dnYA6/cApnf4vAG3dt3Zd41bZkqdVC3wM6Cdi30UEOFSIrFix0SAAAh+QQJCgAAACwAAAAAMgAyAAAD+Ai63P4wykmrvTjrzbv/YCiOZGmeaKqubOu+cCzPdG3f+FjsfA/3wELFILQZBoKiiUcRIJWgnWE6rTiTHymVCJ1cuxnqjlEwWL4dcJlAAEPQIQPbDHA/4Ol5kXCwO/AZBWxtC3wEdRRmgBdzDIYKB4cRBwNCixVjhZEKBAJmm1WdAARICpcYj3UHB3UChwICAJSKA5KnFamjfaOeALAAR6xHsaZPGgabCgaukFgHxL+yA6zFxBhlDKtFAtTRlEIFA5ULyR3LdMuSz5y17NQhBauFvb7E4e9OdFEH+uvNC9GAtVvCDaC1WSwK0KtXaIC+F3zI5JhIcUMCACH5BAkKAAAALAAAAAAyADIAAAP7CLrc/jDKSau9OOvNu/9gKI5kaZ5oqq5s675wLM90bd94rgOEUNyCweCAKvwoBOGAMDI6LYWDUGDoOK8aQ3Dg02AZxoxBSQQZzpuksMopnI9HqHHbxbjRCgMTys1vD3ESdwZxelWBED9BdWpLiA5vDIYKBHsQUj9SAgxSSxOIkwAGB1WVoqWAY2WLkpYWoVFMBQJMB5tJVUFsmo+vBGw8gKKkAAdEWkQFfQqsWb8LsZTCtsybxZ4Kml7AwUfG2WW2P7N1xa4bo2yzu9ZJe0llIdHS3mWz8boiBc/gC9TVC7Rwa3LA0jdKA4D1kkcsmzVRVGSYgrajosUKCQAAIfkECQoAAAAsAAAAADIAMgAAA/YIutz+MMpJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33gOFERxH4OB4GCgGYDBoIBQlPEESWVvZiBAo4ep7HhVHnwYsGa44CEHhEthvSlIGwWDWLJma+pIwdxSLzcrBQICCgZXX3x2CnE+ew8+QIOESWkTfX5NTBJWRZAMSI2VcoRTmQZFBAcABgOpAJ1+GXFNPEUFRK6pm64DTa9toqM+R4+pgWmBkbvJYaZlmQCoCgetZNBoC75qcwSU0JTT0noKgmJZH1Wzt7iEAk2rrSE83cPSrcbYvCI8YtzY8AfJCv0hYasbOAW6VtDyt0Dglm46IkrUkAAAIfkECQoAAAAsAAAAADIAMgAAA90Iutz+MMpJq7046827/2AojmRpnmiqrmzrvnAsz3Rt33gOEEPv/8CfoMQLGoFDnetwMBRsAp+gSTMcolLCs3UgLAqEa2+7KkQFhoYhzSq4D70DueO+mA8KA9ZLr1eecHgKBGd8GW5bThKEgAOCCnADc39+BYprAHVWAHqCgQyWh36caWBpBF6MAFdsnxyIX4pgT6iZXZlTC66iZJaJfLWrgoRsq44bc5iDbMFhWwICZLcevgqmg3x6bHqGIcqcWtjW06vRItV5hsHCC9ooBMXrzm3h4nlUMetK+/wXCQAh+QQJCgAAACwAAAAAMgAyAAAD5Qi63P4wykmrvTjrzbv/YCiOZGmeaKqubOu+cCzDBnHMQEEIQ1+8BcOB1xsICC0hsSc4GH4q3bJ3IEBVhqnRCjswnQxDkUi8kYLXsHHN45lxM9sTDlgeDbia/ZhWVRdBQz4tBW14DEGEOUNNfSwFB2aQW44oP0NvWVsgBZULNj87bwA7Ap4WnQpzqTUAWUikTYiHHamuoUhCoQdQoiO2aK5IkHiQb74htgaHraSwO7TIHrauzM+8i6MEtLVQwcKq2K5HZ1ffzcQLkacaacsLzc7wYCdzqrCu4lH28uHsKO/oCByIIgEAIfkECQoAAAAsAAAAADIAMgAAA+0Iutz+MMpJq7046827/2AojmRpnmiqrqxoEG1UHMNQxA5RDzC+GLuDb1EQ1AS34exoaLxYuloPUCDQasmTwTgQAgwH7nFaKh6TYsGhiVoOBGzFYd3ikocAa5axFfj/fl4tfYB/gniIeWt7eGFvAgQGjDFVjoEEkygEZC9/mSYzanEKBaMpN1WBn6cHPaGQODcEsApgfqZaB7K0CrNIIgWoNwZNMz2zZKUjwV9NL7K6vbxltcWRVK0LyKBJxL1sYHHbJMzNta6bDNfk3WxV3XRtWd5U64qrH+XmvVPv8j9xnrXYQ68evn+JEiqMkQAAIfkECQoAAAAsAAAAADIAMgAAA+sIutz+MMpJq7046827/2AojmTJFOYmECkmDEJrvbFM0fYNMwabMzhF4TAYoH6AIIBQXCGTO4DhNTg8obEC9XBE4gpNQ8MgbikPPkCBcKB2ScqFoV2EoVNxBVWwKpu0UQ1sfjIGgVcOb2N8jI1WT1MCbZN8j4iXDoOKl22VBISIa52eV588bHybKUOSigWgLUeoBKo2az5rkmk/KGxpc5KwJj0Kc7tzln9ia2XGJ7UeBSivKD1HzrbTBtOmxXcy0sXNtHLfq0evCwTH0CDhattC3bxd8cXk9HJ+a+0j7/CY1HShhulfwIMIryQAACH5BAkKAAAALAAAAAAyADIAAAPzCLrc/jDKSau9OOvNu/9QYYAgMRCkNwxjuh3D4W7FWiwCOlPCiQ+C3cSw+gWFkl6rd0RCTEcmw9ByAmqDm1RRgGWtAJhsCyAwq0jsFagw9HxgQE93664OtzixeT03qEgraGE6VwYHAol5LlAQBmZMAgeFKViLDDCJk5czPTIPBASDSGZxIG4HqaqIlHqrr62mskOisxGpkqKctiIEiKm1s4ALj6qzBb4EnAW7ViKpBs1xwcjQtm3BV8mjQiLYaIexLsyGeY9o5E7pIubZpunDAOfHeezE7s6L8fLS3Qv217jo4/ZuEcBr6QI66KewocOHphIAACH5BAkKAAAALAAAAAAyADIAAAP/CLrc/jDKSau9OGtYSNkgRAxEaDLCYCzfuQ3DMq4uZgzCAtO1dZCK36GHSX0KsBbgUCJycIpUE5AaOh+j4S0XHFivjt8qRauCITDAiCtkGHhXZO73aSsKB4FA6czeqV4yKQJwTmQsegoGg1NnaQxHPwIHfGBbDgVVlQWFLj+NMjycBHl7RJkDlW6kepMEnSY3MRClkwaqNXZYr2duB7C9IAYHxMXFoMEAw8bGyMnPFm+40AykxK/T0KPHvNTKfNtf0ATYDQXZZwbkwM9vd+rd3gCcSh3k6D3n73Dw1PrztyDhy1fPnTwWBQeC+fdOYRxwDh8e5BAxWcWJGDNq3MiRAloCADsAAAAAAAAAAAA=')";
        this.cursordiv.style.backgroundRepeat = "no-repeat";
        this.cursordiv.style.backgroundPosition = "125px 50px";
        this.engine.getCanvas().parentElement.appendChild(this.cursordiv);
        //options - set the default values here....
        const defaultoptions = {
            layerstyle: this.toolhandler.defaultstyles.standard,
            referencelinestyle: this.toolhandler.defaultstyles.orthobase,
            enablecbf: null,
            disablecbf: null,
            referencelinesetcbf: null,
            activecursor: "crosshair",
            finishinput: USERINPUTTYPE.LEFTCLICK,
            resetinput: USERINPUTTYPE.RIGHTCLICK,
            autoEdgeDetection: true,
        };
        for (const property in defaultoptions) {
            this.options[property] = defaultoptions[property];
        }
        super.parseOptions(options);
        //create the drawing layers
        this.featurecollection = this.scene
            .getFeatureHandler()
            .createFeatureCollection(this.options.layerstyle, null, "mmExperimentalTool_internal", false);
        this.ref_featurecollection = this.scene
            .getFeatureHandler()
            .createFeatureCollection(this.options.referencelinestyle, null, "mmExperimentalTool_internal", false);
        this.linestringfeature = this.featurecollection.createFeature();
        this.linestringfeature.geometry = this.linestringfeature.createGeometry(GEOMETRYTYPE.LINESTRING);
        this.multipointfeature = this.featurecollection.createFeature();
        this.multipointfeature.geometry = this.multipointfeature.createGeometry(GEOMETRYTYPE.MULTIPOINT);
        this.referencelinefeature = this.ref_featurecollection.createFeature();
        this.referencelinefeature.geometry = this.referencelinefeature.createGeometry(GEOMETRYTYPE.LINESTRING);
        this.type = "OrthogonalMeasurementTool";
    }
    /**
     * internal function - to activate tool call mmSelectFeatureTool.enable
     * @method _enableTool
     * @protected
     */
    _enableTool() {
        this.worker = new Worker(new URL("./orthogonalmeasurement.worker.js", import.meta.url)); //new OrthogonalMeasurementWorker();
        this.worker.addEventListener("message", (e) => {
            const ctx2d = this.cursordiv.getContext("2d");
            const imgdata = ctx2d.getImageData(0, 0, 300, 150);
            imgdata.data.set(e.data);
            this._workerCallback(imgdata);
        }, false);
        this._subscribeEvents();
        this.fire(OrthogonalMeasurementTool.enabled, this.options["cbobject"]);
        this.toolstate = 0;
        this.engine.getCanvas().style.cursor = "progress";
        // For speed define hough line indices on tool enabling
        this._createPointListsForHoughTrafo();
        this.engine.getCanvas().style.cursor = "default";
        this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
    }
    /**
     * internal function - to disable tool call mmSelectFeatureTool.disable
     * @method _disableTool
     * @protected
     */
    _disableTool() {
        if (!this.enabled)
            return; //if tool is not active there is nothing to disable...
        this.scene.getCursorStyleHandler().setCursorStyle("default");
        this.reset();
        this.fire(OrthogonalMeasurementTool.disabled, this.options["cbobject"]);
        this._unSubscribeEvents();
    }
    _subscribeEvents() {
        this._mouseupeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEUP, this._onMouseUp, this);
        this._mousemoveeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._onMouseMove, this);
        this.mouseouteventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEOUT, this._onMouseOut, this);
        this._mousedowneventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEDOWN, this._onMouseDown, this);
        this._drageventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.DRAG, this._onDrag, this);
        if (this.options.resetinput != null) {
            this.resetinputevent = this.scene.userInputHandler.subscribeEvent(this.options.resetinput, this.reset, this);
        }
        if (this.options.finishinput != null) {
            this.finishinputevent = this.scene.userInputHandler.subscribeEvent(this.options.finishinput, this._finishmeasurement, this);
        }
        if (this.options.enablecbf != null) {
            this.on(OrthogonalMeasurementTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.on(OrthogonalMeasurementTool.disabled, this.options.disablecbf);
        }
        if (this.options.continousdrawcbf != null) {
            this.on(OrthogonalMeasurementTool.continousdraw, this.options.continousdrawcbf);
        }
        if (this.options.referencelinesetcbf != null) {
            this.on(OrthogonalMeasurementTool.referencelineset, this.options.referencelinesetcbf);
        }
        if (this.options.resetcbf != null) {
            this.on(OrthogonalMeasurementTool.reset, this.options.resetcbf);
        }
        if (this.options.finishedcbf != null) {
            this.on(OrthogonalMeasurementTool.finished, this.options.finishedcbf);
        }
    }
    _unSubscribeEvents() {
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._mousemoveeventnr);
        this._mousemoveeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEOUT, this.mouseouteventnr);
        this.mouseouteventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEDOWN, this._mousedowneventnr);
        this._mousedowneventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEUP, this._mouseupeventnr);
        this._mouseupeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ENTER, this._keyeventnr);
        this._keyeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.DRAG, this._drageventnr);
        this._drageventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.resetinput, this.resetinputevent);
        this.resetinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.finishinput, this.finishinputevent);
        this.finishinputevent = null;
        if (this.options.enablecbf != null) {
            this.off(OrthogonalMeasurementTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.off(OrthogonalMeasurementTool.disabled, this.options.disablecbf);
        }
        if (this.options.continousdrawcbf != null) {
            this.off(OrthogonalMeasurementTool.continousdraw, this.options.continousdrawcbf);
        }
        if (this.options.referencelinesetcbf != null) {
            this.off(OrthogonalMeasurementTool.referencelineset, this.options.referencelinesetcbf);
        }
        if (this.options.resetcbf != null) {
            this.off(OrthogonalMeasurementTool.reset, this.options.resetcbf);
        }
        if (this.options.finishedcbf != null) {
            this.off(OrthogonalMeasurementTool.finished, this.options.finishedcbf);
        }
    }
    /**
     * Prepares the htindex array for super fast hough transform
     * @method _createPointListsForHoughTrafo
     * @private
     */
    _createPointListsForHoughTrafo() {
        this.htindex = [];
        this.linecoordinates = [];
        const imgd5 = {};
        imgd5.width = this.wwidth;
        imgd5.height = this.wheight;
        for (let k = -2; k < 2; k = k + 1) {
            for (let l = -2; l < 2; l = l + 1) {
                // 1. y = 0 -> y = 300
                for (let j = 0; j < this.wwidth; j++) {
                    const fullline = ImageUtils.LineSegmentToFullLine(this.wwidth / 2 + k, this.wheight / 2 + l, j, 0, imgd5);
                    this.htindex.push(ImageUtils.GetLineImgBufferIndex(fullline[0], fullline[1], fullline[2], fullline[3], imgd5));
                    this.linecoordinates.push(fullline);
                }
                // 2. x = 150 -> x = 0
                for (let j = 1; j < this.wheight - 1; j = j + 1) {
                    const fullline = ImageUtils.LineSegmentToFullLine(this.wwidth / 2 + k - 1, this.wheight / 2 + l - 1, this.wwidth - 1, j, imgd5);
                    this.htindex.push(ImageUtils.GetLineImgBufferIndex(fullline[0], fullline[1], fullline[2], fullline[3], imgd5));
                    this.linecoordinates.push(fullline);
                }
            }
        }
    }
    /**
     * The touch drag event.
     */
    _onDrag(evt) {
        if (this._longpressActive) {
            this._mx = evt.gesture.srcEvent.offsetX = evt.gesture.srcEvent.layerX - 30;
            this._my = evt.gesture.srcEvent.offsetY = evt.gesture.srcEvent.layerY - 30;
            this._onMouseMove(evt.gesture.srcEvent);
        }
    }
    /**
     * internal function - onmouse move event triggers the line finding algorithm
     * @method _onMouseMove
     * @param evt
     * @private
     */
    _onMouseMove(evt) {
        if (this.multipointfeature.ishidden) {
            this.multipointfeature.show();
        }
        if (this._longpressActive)
            this._onMouseUp(null);
        let pos = this.scene
            .getMeasureHandler()
            .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), evt.offsetX, evt.offsetY, 30);
        if (pos.warning) {
            this.scene.getCursorStyleHandler().setCursorStyle("not-allowed");
            return;
        }
        this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
        switch (this.toolstate) {
            case 0: {
                if (this.options.autoEdgeDetection) {
                    //Line finding mode
                    //Hysterese... Check if mouse is more than hist_dist away from the point where the last line was found.
                    const hist_dist = Math.sqrt((this._mx - evt.offsetX) * (this._mx - evt.offsetX) +
                        (this._my - evt.offsetY) * (this._my - evt.offsetY));
                    if (hist_dist < this.histthresh && this.hist_active)
                        return;
                    this.hist_active = false;
                    if (this._mousemoveevt == null && !this.detectionInProgress) {
                        this._mousemoveevt = evt;
                        this.detectionInProgress = true;
                        this.linestringfeature.geometry.clear();
                        this.multipointfeature.geometry.clear();
                        this.linestringfeature.update();
                        this.multipointfeature.update();
                        this._mx = evt.offsetX;
                        this._my = evt.offsetY;
                        this.threshold = this.defaultthresholdval;
                        this.scene.infrascene.getSnapShotAsync(this._mx - this.wwidth / 2, this._my - this.wheight / 2, this.wwidth, this.wheight, (imgBuffer) => {
                            this.scene.infrascene.resetSnapShotAsync();
                            this._snapShotReceived(imgBuffer);
                        });
                    }
                }
                else {
                    // Pick start- / endpoint manually
                    this.multipointfeature.geometry.coordinates[0] = [pos.Easting, pos.Northing, pos.Height];
                    if (this._manualStartPoint) {
                        this.linestringfeature.geometry.coordinates = [
                            [
                                this._manualStartPoint.Easting,
                                this._manualStartPoint.Northing,
                                this._manualStartPoint.Height,
                            ],
                            [pos.Easting, pos.Northing, pos.Height],
                        ];
                    }
                    this._draw();
                }
                break;
            }
            case 1: {
                // Measurement Mode
                // calc the orthogonal distance
                // get current pos
                const p1 = new Vector3(this.referencelinefeature.geometry.coordinates[0][0], this.referencelinefeature.geometry.coordinates[0][1], this.referencelinefeature.geometry.coordinates[0][2]);
                const p2 = new Vector3(this.referencelinefeature.geometry.coordinates[1][0], this.referencelinefeature.geometry.coordinates[1][1], this.referencelinefeature.geometry.coordinates[1][2]);
                const r_line = new Vector3(p1.x, p1.y, p1.z);
                let a_line = p2.sub(p1);
                pos = this._checkSnaping(pos, evt);
                let p = pos.getVec3();
                p = p.sub(r_line);
                const a = new Vector3(a_line.x, a_line.y, a_line.z);
                const b = new Vector3(p.x, p.y, p.z);
                const na = a_line.length();
                a_line = a_line.cross(p);
                const nb = a_line.length();
                const d = nb / na;
                this.distance = d;
                this.fire(OrthogonalMeasurementTool.continousdraw, this.options["cbobject"], { distance: d }, evt);
                const f = new Vector3(a.x, a.y, a.z).dot(b) / a.lengthSq();
                const val = [a.x * f + r_line.x, a.y * f + r_line.y, a.z * f + r_line.z];
                this.linestringfeature.geometry.coordinates[0] = val;
                this.linestringfeature.geometry.coordinates[1] = [pos.getVec3().x, pos.getVec3().y, pos.getVec3().z];
                this.multipointfeature.geometry.coordinates[0] = val;
                this.multipointfeature.geometry.coordinates[1] = [pos.getVec3().x, pos.getVec3().y, pos.getVec3().z];
                this._draw();
                break;
            }
            default:
                break;
        }
    }
    /**
     * internal function mouseout
     * @method _onMouseOut
     * @param evt
     * @private
     */
    _onMouseOut(evt) {
        this.multipointfeature.hide();
        this.multipointfeature.update(true);
    }
    _checkSnaping(pos, evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        if (this.options.snaplayer && !evt.altKey) {
            const snapdataarray = this.scene.getFeatureHandler().snap(mx, my, this.options.snaplayer);
            //prevent self pickcing and filter non-pointy geometries
            for (let i = snapdataarray.length - 1; i >= 0; i--) {
                if (snapdataarray[i].geometry.type != GEOMETRYTYPE.MULTIPOINT &&
                    snapdataarray[i].geometry.type != GEOMETRYTYPE.POINT) {
                    snapdataarray.splice(i, 1);
                }
            }
            if (snapdataarray.length > 0) {
                const snapdata = snapdataarray[0];
                this.snap_mx = snapdata.found_mx;
                this.snap_my = snapdata.found_my;
                pos.Easting = snapdata.found_easting;
                pos.Northing = snapdata.found_northing;
                pos.Height = snapdata.found_height;
                pos.warning = false;
                this.snappedpos = pos;
            }
            else {
                this.snap_mx = null;
                this.snap_my = null;
                this.snappedpos = null;
                return this.scene
                    .getMeasureHandler()
                    .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), mx, my, 30);
            }
            return pos;
        }
        return this.scene.getMeasureHandler().createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), mx, my, 30);
    }
    /**
     * internal function - onmouse down starts advanced line search
     * @method _onMouseDown
     * @param evt
     * @private
     */
    _onMouseDown(evt) {
        if (evt.button == this.options.finishinput && this.toolstate == 0 && this.options.autoEdgeDetection) {
            setTimeout(() => {
                this._longpressActive = true;
                this._onTick();
            }, 300);
        }
    }
    /**
     * removes all drawing from the scene
     * @method reset
     * @param {?Object} evt EventObject if called from userinput
     * @public
     */
    reset(evt) {
        this.toolstate = 0;
        this.hist_active = false;
        this.linestringfeature.geometry.clear();
        this.multipointfeature.geometry.clear();
        this.referencelinefeature.geometry.clear();
        this._manualStartPoint = undefined;
        this._draw();
        this.fire(OrthogonalMeasurementTool.reset, this.options["cbobject"], evt);
    }
    /**
     * internal function - advanced line search with  deceased threshold
     * @method _onTick
     * @private
     */
    _onTick() {
        if (this.threshold > 0) {
            this.threshold = this.threshold - 20;
            this._snapShotReceived(this.imgbuffer);
        }
        else {
            this._onMouseUp(null);
        }
    }
    /**
     * internal function - stops advanced line search
     * @method _onMouseUp
     * @param evt
     * @private
     */
    _onMouseUp(evt) {
        if (evt && evt.isDragging)
            return;
        if (this.toolstate == 0 && evt && evt.button == this.options.finishinput && !this.options.autoEdgeDetection) {
            // If manual start- / endpoint is set
            const pos = this.scene
                .getMeasureHandler()
                .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), evt.offsetX, evt.offsetY, 30);
            if (pos.warning) {
                this.scene.getCursorStyleHandler().setCursorStyle("not-allowed");
                return;
            }
            this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
            if (!this._manualStartPoint) {
                // Set the startpoint
                this.multipointfeature.geometry.coordinates.push([pos.Easting, pos.Northing, pos.Height]);
                this._manualStartPoint = pos;
            }
            else {
                // Set the endpoint and continue
                this.referencelinefeature.geometry.coordinates = [
                    [this._manualStartPoint.Easting, this._manualStartPoint.Northing, this._manualStartPoint.Height],
                    [pos.Easting, pos.Northing, pos.Height],
                ];
                this.fire(OrthogonalMeasurementTool.referencelineset, this, [
                    [this._manualStartPoint.Easting, this._manualStartPoint.Northing, this._manualStartPoint.Height],
                    [pos.Easting, pos.Northing, pos.Height],
                ]);
                this._manualStartPoint = undefined;
                this.toolstate = 1;
            }
            this._draw();
        }
        else if ((this.toolstate == 1 && evt && evt.button == this.options.finishinput) ||
            (this.toolstate != 1 && (!evt || (evt && evt.button != this.options.resetinput)))) {
            this.cursordiv.style.left = 0 + "px";
            this.cursordiv.style.top = 0 + "px";
            this.cursordiv.style.visibility = "hidden";
            this.cursordiv.style.opacity = "0.75";
            this._longpressActive = false;
            this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
            if (this.linestringfeature.geometry.coordinates.length > 1) {
                switch (this.toolstate) {
                    case 0: //Line Finding Mode
                        this.referencelinefeature.geometry.coordinates =
                            this.linestringfeature.geometry.coordinates.slice(0); //copy the array
                        this.referencelinefeature.update();
                        this.toolstate = 1;
                        this.fire(OrthogonalMeasurementTool.referencelineset, this, this.referencelinefeature.geometry.coordinates);
                        break;
                    case 1: //Measurement Mode
                        if (evt.isDragging)
                            return;
                        if (evt.ctrlKey) {
                            this.referencelinefeature.geometry.coordinates =
                                this.linestringfeature.geometry.coordinates.slice(0); //copy the array
                            this.referencelinefeature.update();
                        }
                        else {
                            if (this.scene.getMeasureMode() == 1 && evt.offsetX) {
                                this._unSubscribeEvents();
                                this.scene.getMeasureHandler().createMeasurePointInMeasureMode(this.scene.getCurrentGeoframe(), evt.offsetX, evt.offsetY, this.options.maxdist, (pos) => {
                                    this._posRequestSuccess(pos);
                                }, (pos) => {
                                    this._posRequestFailed();
                                }, this.scene.getMeasureMode());
                            }
                            this.toolstate = 2;
                        }
                        break;
                    case 2: //Finished Mode
                        this.referencelinefeature.geometry.coordinates =
                            this.linestringfeature.geometry.coordinates.slice(0); //copy the array
                        this.toolstate = 1;
                        break;
                }
            }
        }
    }
    /**
     * If point is set in LeftRight Meassure Mode first point has to be replaced to keep orthogonallity
     * @param pos
     * @private
     */
    _posRequestSuccess(pos) {
        setTimeout(() => {
            this._subscribeEvents();
        }, 10);
        const p1 = new Vector3(this.referencelinefeature.geometry.coordinates[0][0], this.referencelinefeature.geometry.coordinates[0][1], this.referencelinefeature.geometry.coordinates[0][2]);
        const p2 = new Vector3(this.referencelinefeature.geometry.coordinates[1][0], this.referencelinefeature.geometry.coordinates[1][1], this.referencelinefeature.geometry.coordinates[1][2]);
        const r_line = new Vector3(p1.x, p1.y, p1.z);
        let a_line = p2.sub(p1);
        let p = pos.getVec3();
        p = p.sub(r_line);
        const a = new Vector3(a_line.x, a_line.y, a_line.z);
        const b = new Vector3(p.x, p.y, p.z);
        const na = a_line.length();
        a_line = a_line.cross(p);
        const nb = a_line.length();
        this.distance = nb / na;
        const f = new Vector3(a.x, a.y, a.z).dot(b) / a.lengthSq();
        const val = [a.x * f + r_line.x, a.y * f + r_line.y, a.z * f + r_line.z];
        this.linestringfeature.geometry.coordinates[0] = val;
        this.linestringfeature.geometry.coordinates[1] = [pos.getVec3().x, pos.getVec3().y, pos.getVec3().z];
        this.multipointfeature.geometry.coordinates[0] = val;
        this.multipointfeature.geometry.coordinates[1] = [pos.getVec3().x, pos.getVec3().y, pos.getVec3().z];
        this._draw();
    }
    _posRequestFailed() {
        this.reset();
        this.scene.getMeasureHandler().abortMeasureSequence();
        setTimeout(() => {
            this._subscribeEvents();
        }, 10);
    }
    /**
     * internal function - image buffer received -> search line....
     * @method _snapShotReceived
     * @param {Uint8Array} imgbuffer
     * @private
     */
    _snapShotReceived(imgbuffer) {
        if (imgbuffer == null)
            return;
        this.imgbuffer = imgbuffer;
        this.worker.postMessage({ imgbuffer: imgbuffer, width: this.wwidth, height: this.wheight });
    }
    _workerCallback(imgd1) {
        // Threshold Image
        ImageUtils.Threshold(imgd1, this.threshold);
        const ctx2d = this.cursordiv.getContext("2d");
        const imgd5 = ctx2d.getImageData(0, 0, this.wwidth, this.wheight);
        // Erosion to get thinner line
        ImageUtils.Erode(imgd1, imgd5, [1, 1, 1, 1]);
        // Partial Hough Transform
        // and determine min, mean and max
        let rc = [];
        let max = 0;
        let min = 255;
        let mean = 0;
        let maxlinedef = [];
        let idx = 0;
        const numlines = this.htindex.length;
        for (let i = 0; i < numlines; i++) {
            const numindices = this.htindex[i].length;
            const inc = this.htinc;
            let sum = 0;
            for (let j = 0; j < numindices; j = j + inc) {
                idx = this.htindex[i][j];
                sum = sum + imgd5.data[idx];
            }
            sum = sum / (numindices / inc);
            if (sum > max) {
                max = sum;
                maxlinedef = this.linecoordinates[i];
            }
            if (sum < min && sum > 0)
                min = sum;
            mean = mean + sum / numlines;
        }
        this.min = min;
        this.max = max;
        this.mean = mean;
        // Find 3d Point on best line and start RANSAC
        let posforransac = [];
        let plist2 = [];
        const maxgap = this.maxgap;
        if (max - mean > this.peakthresh) {
            // a line found
            this._longpressActive = false;
            this.hist_active = true;
            this.linestringfeature.geometry.clear();
            this.multipointfeature.geometry.clear();
            //line from middle up
            // transorm the line in main canvas coordinates
            let mx = Math.abs(maxlinedef[0] - maxlinedef[2]) / 2;
            if (maxlinedef[0] < maxlinedef[2]) {
                mx = mx + maxlinedef[0];
            }
            else {
                mx = mx + maxlinedef[2];
            }
            mx = Math.round(mx);
            let my = Math.abs(maxlinedef[1] - maxlinedef[3]) / 2;
            if (maxlinedef[1] < maxlinedef[3]) {
                my = my + maxlinedef[1];
            }
            else {
                my = my + maxlinedef[3];
            }
            my = Math.round(my);
            const plist1 = ImageUtils.GetLineImgBufferIndex(mx, my, maxlinedef[0], maxlinedef[1], imgd5);
            plist2 = ImageUtils.GetLineImgBufferIndex(mx, my, maxlinedef[2], maxlinedef[3], imgd5);
            let gap = 0;
            for (let p = 0; p < plist1.length; p++) {
                imgd5.data[plist1[p] + 1] = 255;
                if (gap < maxgap || p < 30) {
                    rc = ImageUtils.ImgBufferIndexToRowCol(plist1[p], imgd5);
                    const mmx = rc[1] + this._mx - this.wwidth / 2;
                    const mmy = rc[0] + this._my - this.wheight / 2;
                    const pos = this.scene
                        .getMeasureHandler()
                        .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), mmx, mmy, 100);
                    if (!pos.warning) {
                        posforransac.push(pos);
                        if (imgd5.data[plist1[p]] < 100) {
                            gap++;
                        }
                        else {
                            gap = 0;
                        }
                    }
                }
                else {
                    const len = posforransac.length;
                    posforransac = posforransac.slice(0, len - maxgap);
                    break;
                }
            }
            posforransac.reverse();
            //line from middle down
            gap = 0;
            for (let p = 0; p < plist2.length; p++) {
                imgd5.data[plist2[p] + 2] = 255;
                imgd5.data[plist2[p] + 1] = 255;
                if (gap < maxgap || p < 30) {
                    rc = ImageUtils.ImgBufferIndexToRowCol(plist2[p], imgd5);
                    const mmx = rc[1] + this._mx - this.wwidth / 2;
                    const mmy = rc[0] + this._my - this.wheight / 2;
                    const pos = this.scene
                        .getMeasureHandler()
                        .createMonoplotMeasurePoint(this.scene.getCurrentGeoframe(), mmx, mmy, 100);
                    if (!pos.warning) {
                        posforransac.push(pos);
                        if (imgd5.data[plist2[p]] < 100) {
                            gap++;
                        }
                        else {
                            gap = 0;
                        }
                    }
                }
                else {
                    const len = posforransac.length;
                    posforransac = posforransac.slice(0, len - maxgap);
                    break;
                }
            }
            const lincoords = ImageUtils.RansacLineFit(posforransac);
            if (lincoords != null) {
                this.linestringfeature.geometry.coordinates.push(lincoords[0]);
                this.linestringfeature.geometry.coordinates.push(lincoords[1]);
                this.linestringfeature.update();
                this.multipointfeature.geometry.coordinates.push(lincoords[0]);
                this.multipointfeature.geometry.coordinates.push(lincoords[1]);
                this.multipointfeature.update();
            }
        }
        //show cursordiv on correct location
        if (this._longpressActive) {
            this.cursordiv.style.left = this._mx - this.wwidth / 2 + "px";
            this.cursordiv.style.top = this._my - this.wheight / 2 + "px";
            //sets the canvas under cursor, maybe there was a dragstart event before...
            this.scene.infrascene.traversalState.drag = false;
            this.cursordiv.style.visibility = "visible";
        }
        this._mousemoveevt = null;
        this.detectionInProgress = false;
        this._draw();
        if (this._longpressActive) {
            this._onTick();
        }
    }
    /**
     * Draws the feature into the scene
     * @method _draw
     * @private
     */
    _draw() {
        this.featurecollection.update();
        this.ref_featurecollection.update();
    }
    /**
     * Finish measurement
     * @method _finishmeasurement
     * @private
     */
    _finishmeasurement(evt) {
        if (this.toolstate == 2 || (this.toolstate == 1 && !evt.ctrlKey)) {
            const linestringfeature = this.linestringfeature.toGeoJSON();
            this.fire(OrthogonalMeasurementTool.finished, this.options["cbobject"], { linestringfeature: linestringfeature, distance: this.distance }, evt);
        }
    }
    setAutoEdgeDetection(toggle) {
        this.options.autoEdgeDetection = toggle;
        this.reset();
    }
}
OrthogonalMeasurementTool.enabled = "enabled";
OrthogonalMeasurementTool.disabled = "disabled";
OrthogonalMeasurementTool.continousdraw = "continousdraw";
OrthogonalMeasurementTool.referencelineset = "referencelineset";
OrthogonalMeasurementTool.reset = "reset";
OrthogonalMeasurementTool.finished = "finished";
//# sourceMappingURL=orthogonalmeasurementtool.js.map